import React from 'react';
import { Button, Typography } from 'antd';

const { Text, Paragraph } = Typography;

export default function SelectableListButton({
  title,
  subtitle = null,
  isSelected = false,
  onClick,
  testId
}) {
  return (
    <Button
      block
      onClick={onClick}
      data-testid={testId}
      style={{ 
        padding: '12px', 
        textAlign: 'left', 
        height: 'auto',
        whiteSpace: 'normal',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginBottom: '8px',
        backgroundColor: isSelected ? '#f0f7ff' : '#ffffff',
        border: isSelected ? '1px solid #1890ff' : '1px solid #d9d9d9',
        color: isSelected ? '#1890ff' : 'inherit',
        boxShadow: 'none'
      }}
    >
      <Text strong style={{ display: 'block', fontSize: '16px' }}>
        {title}
      </Text>
      {subtitle && (
        <Paragraph type={isSelected ? 'primary' : 'secondary'} style={{ fontSize: '14px', margin: 0 }}>
          {subtitle}
        </Paragraph>
      )}
    </Button>
  );
}


